import { index } from "~/api/contractSpendingMonthly";
import * as types from "../mutation-types";
import store from "../../store";

function resolveMonthlySpendingPayload(payload) {
  if (Array.isArray(payload)) {
    return payload;
  }

  if (Array.isArray(payload?.data)) {
    return payload.data;
  }

  if (Array.isArray(payload?.data?.data)) {
    return payload.data.data;
  }

  return [];
}

export const state = {
  list: [],
  isLoading: false,
  updatedAt: null
};

export const mutations = {
  [types.SET_IS_LOADING_CONTRACT_SPENDING_MONTHLY](state, status) {
    state.isLoading = status;
  },
  [types.SET_CONTRACT_SPENDING_MONTHLY_DATA](state, data) {
    state.list = Array.isArray(data) ? data : [];
  },
  [types.CLEAR_CONTRACT_SPENDING_MONTHLY_DATA](state) {
    state.list = [];
  },
  [types.SET_CONTRACT_SPENDING_MONTHLY_UPDATED_AT](state, timestamp) {
    state.updatedAt = timestamp;
  }
};

export const actions = {
  async fetchContractSpendingMonthly({ commit }, contractId = null) {
    commit(types.SET_IS_LOADING_CONTRACT_SPENDING_MONTHLY, true);

    const activeContractId =
      contractId || store.getters["contract/activeContract"]?.id;

    if (!activeContractId) {
      commit(types.CLEAR_CONTRACT_SPENDING_MONTHLY_DATA);
      commit(types.SET_IS_LOADING_CONTRACT_SPENDING_MONTHLY, false);
      return null;
    }

    try {
      const response = await index(activeContractId);
      commit(
        types.SET_CONTRACT_SPENDING_MONTHLY_DATA,
        resolveMonthlySpendingPayload(response?.data)
      );
      commit(types.SET_CONTRACT_SPENDING_MONTHLY_UPDATED_AT, Date.now());

      return response;
    } finally {
      commit(types.SET_IS_LOADING_CONTRACT_SPENDING_MONTHLY, false);
    }
  }
};

export const getters = {
  list: (state) => state.list,
  isLoading: (state) => state.isLoading,
  updatedAt: (state) => state.updatedAt
};
